// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import AdminPanel from "./AdminPanel";
import { initializeFirebase } from "./firebase"; // 👈 Import your init function

initializeFirebase()
  .then(() => {
    const root = ReactDOM.createRoot(document.getElementById("root"));
    root.render(<AdminPanel />);
  })
  .catch((err) => {
    console.error("🔥 Firebase initialization failed:", err.message);
    // Optionally render a fallback error UI here
  });
